<template>
  <div class="home-total">
    <div class="container-top">
      <!--      <div style="font-weight: bold;">销售汇总数据</div>-->
      <!--      <menu-list></menu-list>-->
      <div class="button-type">
        <search-form-template
          ref="storeTemplate"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          @btnCommon="btnCommon"
        >
        </search-form-template>
      </div>
    </div>
    <div class="container-bottom">
      <div class="container-left">
        <div class="sale-data">
          <div class="sale-data-list">
            <div class="sale-data-data" v-for="(v, i) in datalist" :key="i"
                 :style="{'background-image':'url('+v.background+')'}">
              <div :style="{ color: v.color,paddingLeft:'5px'}">0</div>
              <span class="sale-data-title" style="color:#fff">{{ v.data }}</span>
            </div>
          </div>
        </div>
        <div class="charts-data">
          <div class="charts-data-list">
            <span>今日销售实时时段数据<span style="color: #999;font-size: 14px">(数据更新截止时间{{ saleNewTime }})</span></span>
            <div>
              <!--              <echarts-template-->
              <!--                class="charts-line"-->
              <!--                ref="leftTopPic"-->
              <!--                :picOption="leftTopPic"-->
              <!--              ></echarts-template>-->
              <echarts-template
                class="charts-line"
                ref="saleHours"
                :picOption="saleHours"
              ></echarts-template>
            </div>
          </div>
          <div class="charts-data-list" style="margin-bottom: 14px">
            <span>支付方式汇总数据</span>
            <div class="paymentData">
              <echarts-template
                class="charts-box"
                ref="rightTopPic"
                :picOption="rightTopPic"
              ></echarts-template>
            </div>
          </div>
        </div>
        <div class="charts-data">
          <div class="charts-data-list">
            <span>Top商品销售数据</span>
            <div style="height:280px">
              <list-template
                class="list-template"
                ref="saleRank"
                :tableOptions="tableOptions"
                :tableData="tableData"
              >
              </list-template>
            </div>
          </div>
          <div class="charts-data-list">
            <span>Top6销售类别数据</span>
            <div class="">
              <el-tabs v-model="activeTab" @tab-click="handleClickTab">
                <el-tab-pane label="销量" name="saleNumber">
                  <div class="centerBack3">
                    <div class="echartsArea3" v-if="tableSaleData.length != 0">
                      <echarts-template
                        v-if="'saleNumber'==activeTab"
                        ref="rightBottomRightPic"
                        :picOption="rightBottomRightPic"
                        class="charts-bottomRight"
                      ></echarts-template>
                    </div>
                    <div class="echartsArea3" v-else>
                      <div class="echartsArea3-empty">暂无数据</div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="金额" name="saleMoney">
                  <div class="centerBack3">
                    <div class="echartsArea3" v-if="tableSaleData.length != 0">
                      <echarts-template
                        v-if="'saleMoney'==activeTab"
                        ref="rightBottomRightPic"
                        :picOption="rightBottomRightPic"
                        class="charts-bottomRight"
                      ></echarts-template>
                    </div>
                    <div class="echartsArea3" v-else>
                      <div class="echartsArea3-empty">暂无数据</div>
                    </div>
                    <!--                    <div class="threeTable">-->
                    <!--                      <list-template-->
                    <!--                        ref="saleRank"-->
                    <!--                        :tableOptions="categoryCasherTable"-->
                    <!--                        :tableData="tableSaleData"-->
                    <!--                      >-->
                    <!--                      </list-template>-->
                    <!--                    </div>-->
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="container-right">
        <div class="mes-data">
          <span>业务代办</span>
          <div id="scrolldiv">
            <!--            <div id="scroll1">-->
            <li :class="{oneColor:a%5===0,twoColor:a%5===1,threeColor:a%5===2,fourColor:a%5===3,fiveColor:a%5===4}"
                v-for="(v, a) in mesdatalist" :key="a" :data-unit="a + 1"
                @click="toBusinessDetail(v)"
            >
              [{{ v.typeName }}]{{ v.retaleTypeName }}
              <span>{{ v.number }}</span>
            </li>
            <!--            </div>-->
            <!--            <div id="scroll2"></div>-->
          </div>
        </div>
        <div class="mes-data">
          <span>系统提示</span>
          <div id="scrolldiv1">
            <!--            <div id="scroll11">-->
            <li :class="{oneColor:a%5===0,twoColor:a%5===1,threeColor:a%5===2,fourColor:a%5===3,fiveColor:a%5===4}"
                v-for="(v, a) in mesdatalist1" :key="a" :data-unit="a + 1"
                @click="toBusinessDetail(v)"
            >
              {{ v.typeName }}
              <span>{{ v.tipsNumber }}</span>
            </li>
            <!--            </div>-->
            <!--            <div id="scroll21"></div>-->
          </div>
        </div>
        <div class="mes-data">
          <span>限时免费--店小二隆重上线</span>
          <div class="code">
            <img src="../../static/appletLogo.jpg" alt=""/>
            <div class="code-text">
              <p>移动管店助手</p>
              <p>让店面管理更简单</p>
            </div>
          </div>
        </div>
<!--        <div class="mes-data1">
          <span>广告</span>
          <div class="block" style="padding-bottom:10px">
            <el-carousel height="150px" :interval="3000">
              <el-carousel-item v-for="(v, d) in imglist" :key="d">
                <h3 class="small">
                  <el-image
                    style="width:100%;height:140px"
                    fit="fill"
                    :src="v.img"
                    @click="openImg"
                  >
                  </el-image>
                </h3>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div id="imgbox">
            <i class="el-icon-circle-close" @click="cancel"></i>
            <img src="" alt="" class="show" id="image"/>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import echartsTemplate from "@/components/controls/echarts";
import api from "@/config/api";
import listTemplate from "@/components/template/listTemplate";
import userPower from '@/mixin/userPower'
import {leftTopPic, rightBottomRightPic, rightTopPic, centerBottomPic, saleHours} from "./home/options/echartsOptions";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from '@/components/template/tableTemplate';
import menuList from '@/components/business/menuList';

export default {
  mixins: [userPower],
  name: "index",
  components: {echartsTemplate, listTemplate, searchFormTemplate, tableTemplate, menuList},
  data() {
    let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
      saleNewTime: this.$moment().format('HH:mm:ss'),
      percentage: [],
      activeTab: 'saleNumber',
      nodata: false,
      param: defaultParam,
      tableData: [],
      tableSaleData: [],
      rightTopPic,
      leftTopPic,
      saleHours,
      rightBottomRightPic,
      centerBottomPic,
      datalist: [
        {data: "门店销售汇总数据(元)", color: "#fff", background: "../static/index-blue.png"},
        {data: "销售客单数(笔)", color: "#fff", background: "../static/index-red.png"},
        {data: "退货金额(元)", color: "#fff", background: "../static/index-purple.png"},
        {data: "退货单数(笔)", color: "#fff", background: "../static/index-yellow.png"},
        {data: "储值金额(元)", color: "#fff", background: "../static/index-green.png"},
      ],
      mesdatalist: [],
      mesdatalist1: [],
      paymentTotal: [],
      tableOptions: {
        // indexShow:true,
        height: "100%",
        columns: [
          {label: "排名", prop: "src", align: "center", width: "30", deal: this.tableDataIndex},
          // {label: "排名", prop: "src", align: "left",width:"30",type:'image',deal:this.sortNum},//tableDataIndex
          {label: "商品名称", prop: "goodsName", align: "left", width: "150"},
          {label: "金额", prop: "allSum", align: "left", width: "50"},
        ],
      },
      payMentTable: {
        indexShow: true,
        columns: [
          {label: '支付方式', prop: "payName", align: 'center', width: "120"},
          {label: '销售额', prop: "allMoney", align: 'center', width: "80"},
          {label: '营业占比', prop: "payPriceRate", align: 'center', type: "progress"},
        ]

      },
      //广告
      imglist: [
        {img: require("../../static/swiper1.png")},
        {img: require("../../static/swiper2.png")},
        {img: require("../../static/swiper3.png")},
      ],
      searchOptions: {
        simple: [
          {
            label: "",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            // dateType:"daytime",
            rangeButton: [
              {label: "今天", value: 1},
              {label: "昨天", value: 2},
              {label: "本周", value: 4},
              {label: "上周", value: 5},
              {label: "本月", value: 6},
              {label: "上月", value: 7},
            ],
            span: 24,
          },
          {
            label: "",
            prop: "storeId",
            type: "select",
            data: [],
            placeholder: "所有门店",
            hidden: false,
            isHasAll: true,
            url: api.system.seStore,
          },
        ],
      },
      //商品分类销售排名
      //商品分类销售排名
      categorySaleNumberTable: {
        paginationSize: 40,
        indexShow: false,//是否显示索引
        columns: [
          {
            label: '商品分类',
            prop: 'goodsCategoryName',
            width: '85',
            align: 'center'
          },
          {
            label: '销量',
            prop: 'goodsNum',
            width: '65',
            align: 'center'
          },
          {
            label: '占比',
            prop: 'numProportionRate',
            width: '65',
            align: 'center'
          },
          {
            label: '同比',
            prop: 'numSameRate',
            width: '65',
            align: 'center'
          },
          {
            label: '环比',
            prop: 'numSurroundRate',
            width: '65',
            align: 'center'
          },
        ],
        // url: api.report.categoryStatical
      },
      categoryCasherTable: {
        indexShow: false,//是否显示索引
        columns: [
          {
            label: '商品分类',
            prop: 'goodsCategoryName',
            width: '85',
            align: 'center'
          },
          {
            label: '金额',
            prop: 'allSum',
            width: '65',
            align: 'center'
          },
          {
            label: '占比',
            prop: 'sumProportionRate',
            width: '50',
            align: 'center'
          },
          {
            label: '同比',
            prop: 'sumSameRate',
            width: '50',
            align: 'center'
          },
          {
            label: '环比',
            prop: 'sumSurroundRate',
            width: '50',
            align: 'center'
          },
        ],
        // url: api.report.categoryStatical
      },
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
    //业务代办
    this.businessAgent();
    //销售汇总数据
    this.saleData(this.param);
    //Top商品销售数据
    this.salesRanking(this.param);
    //业务数据汇总
    this.paymentSummary(this.param)
    //类比销售数据
    // this.goodSellData(this.param),
    this.handleClickTab({name: this.activeTab})
    //销售实时数据
    this.actualLineData()
    //客流统计数据
    // this.passengerFlow(),
    //系统提示
    this.businessTips()
    // 实时数据
    // this.lineSpeed();
    // 消息提醒
    this.messageAlert();
  },
  updated() {
    // this.scroll(), this.scroll1()
  },
  mounted() {
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {

    // 消息提醒
    messageAlert() {
      let param = {
        stExecutionTime: this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        edExecutionTime: this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        merchantId: this.$utils.getSysUser().merchantId,
        type: 10
      }
      let than = this;
      this.$axios.fetchPost(api.store.seNotice + '/list', param).then(res => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.$notify({
                title: res.data[i].title,
                dangerouslyUseHTMLString: true,
                position: 'bottom-right',
                duration: 0,
                // message: '<strong> <h4>尊敬的用户您好:<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年7月9日凌晨2点至4点系统进行维护，请及时做好准备</p></h4></strong>',
                message: res.data[i].content,
                onClose: function () {
                  let updateParam = {id: res.data[i].id, status: 99};
                  than.$axios.fetchPut(api.store.seNotice, updateParam).then(rep => {
                    if (rep.code === 200) {
                    }
                  });
                }
              });
            }
          }
        }
      });
    },

    // 业务代办 系统提示跳转
    toBusinessDetail(val) {
      let arr = this.$utils.deepClone(this.$router.options.routes)
      let routeList = arr.filter(v => v.path === '/')[0]
      routeList.children.forEach(v => {
        if (v.path === val.businessUrl) {
          this.$axios.fetchPost(api.checkPrivilege, {roleId: this.$utils.getSysUser().roleId}).then(res => {
            if (res.code === 200) {
              if (res.data && val.businessUrl) {
                this.addMenuList(val)
                this.$router.push({name: v.name, params: val})
              } else {
                this.$message.warning('暂无菜单权限')
              }
            } else {
              this.$message.error(res.errorMsg || '跳转权限检测失败')
            }
          })
        }
      })

    },
    // // 系统提示跳转
    // toSysTips(val){
    //   console.log(val)
    //   this.$axios.fetchPost(api.checkPrivilege,{roleId:this.$utils.getSysUser().roleId}).then(res=>{
    //     if(res.code === 200){
    //       if(res.data && val.businessUrl){
    //         this.addMenuList(val)
    //         this.$router.push({path:val.businessUrl,query:val})
    //       }else{
    //         this.$message.warning('暂无菜单权限')
    //       }
    //     }else{
    //       this.$message.error(res.errorMsg || '跳转权限检测失败')
    //     }
    //   })
    // },
    // 添加头部 记录菜单
    addMenuList(menu) {
      let menuList = this.$utils.getClickMenu().filter(v => v.url != '/index')
      menuList.map((item) => {
        item.active = false;
      });
      let currentMenu = menuList.filter((item) => {
        return item.url === menu.businessUrl;
      });
      if (currentMenu.length === 0) {
        menu.active = true;
        menu.name = menu.menuName
        menu.url = menu.businessUrl
        menuList.push(menu);
      } else {
        currentMenu[0].active = true;
      }
      this.$utils.setClickMenu(menuList);
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, menuList);
    },
    // 类比销售数据 切换销量和金额
    handleClickTab(tab) {
      // console.log(tab.name)
      let type = null
      if (tab.name == 'saleNumber') {
        type = 20
      } else {
        type = 10
      }
      let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
      let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
      let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm, type: type};
      this.goodSellData(defaultParam)
    },
    //显示图标
    tableDataIndex(row, column, index) {
      if (index === 0) {
        return '<img src="../../static/gold.png"/>';
      } else if (index === 1) {
        return '<img src="../../static/sliver.png"/>';
      } else if (index === 2) {
        return '<img src="../../static/bronze.png"/>';
      } else {
        let val = index + 1
        if (val % 2 === 0) {//偶数
          return '<span class="sort-num-green">' + val + '</span>'
        } else {
          return '<span class="sort-num-orange">' + val + '</span>'
        }
      }
    },
    //垂直轮播
    scroll() {
      let speed = 200;
      let wrapper = document.getElementById("scrolldiv");
      let list_one = document.getElementById("scroll1");
      let list_two = document.getElementById("scroll2");
      list_two.innerHTML = list_one.innerHTML;

      function Marquee() {
        if (list_two.offsetHeight - wrapper.scrollTop <= 0)
          wrapper.scrollTop -= list_one.offsetHeight;
        else {
          wrapper.scrollTop += 1;
        }
      }

      let MyMar = setInterval(Marquee, speed);
      wrapper.onmouseover = function () {
        clearInterval(MyMar);
      };
      wrapper.onmouseout = function () {
        MyMar = setInterval(Marquee, speed);
      };
    },
    scroll1() {
      let speed = 200;
      let wrapper1 = document.getElementById("scrolldiv1");
      let list_one1 = document.getElementById("scroll11");
      let list_two1 = document.getElementById("scroll21");
      list_two1.innerHTML = list_one1.innerHTML;

      function Marquee1() {
        if (list_two1.offsetHeight - wrapper1.scrollTop <= 0)
          wrapper1.scrollTop -= list_one1.offsetHeight;
        else {
          wrapper1.scrollTop += 1;
        }
      }

      let MyMar1 = setInterval(Marquee1, speed);
      wrapper1.onmouseover = function () {
        clearInterval(MyMar1);
      };
      wrapper1.onmouseout = function () {
        MyMar1 = setInterval(Marquee1, speed);
      };
    },
    //广告点击放大
    openImg() {
      let smallimg = document.querySelectorAll(".small img");
      for (let i = 0; i < smallimg.length; i++) {
        smallimg[i].onclick = function (event) {
          let _this = event.target || event.srcElement;
          document.getElementById("image").src = _this.src;
          document.getElementById("imgbox").style.display = "block";
          document.getElementById("imgbox").style.zIndex = 999;
        };
      }
    },
    cancel() {
      document.getElementById("imgbox").style.display = "none";
    },
    //业务代办
    businessAgent(param) {
      let userid = this.$utils.getSysUser().id;
      let params = {reviewerId: userid, addType: 20, type: 10};
      // let $businessparams = Object.assign({},param,params);
      this.$axios
        .fetchPost(api.archives.businessAgent, params)
        .then((data) => {
          if (data.code == 200 && data.data.length > 0) {
            this.mesdatalist = data.data;
          } else if (data.data.length === 0) {
            let nomessage = document.getElementById('scrolldiv')
            // let nomessage = document.getElementById("scroll1");
            // let nomessage1 = document.getElementById("scroll2");
            // nomessage1.style.display = "none";
            nomessage.innerHTML = "暂无业务代办";
            nomessage.style.textAlign = "center";
            nomessage.style.fontSize = "12",
              nomessage.style.color = "#cccccc";
            nomessage.style.lineHeight = "75px";
          }
        })
        .catch((err) => {
        });
    },
    //系统提示
    businessTips() {
      this.$axios.fetchPost(api.archives.hometips).then((data) => {
        if (data.code == 200) {
          this.mesdatalist1 = data.data;
          if (data.data.length === 0) {
            let tip = document.getElementById('scrolldiv1')
            tip.innerHTML = "暂无系统提示";
            // let tip = document.getElementById("scroll11")
            // let tip1 = document.getElementById("scroll21")
            // tip1.style.display = "none";
            // tip.innerHTML = "暂无系统提示";
            tip.style.textAlign = "center";
            tip.style.fontSize = "12",
              tip.style.color = "#cccccc";
            tip.style.lineHeight = "75px";
          }
        }
      });
    },
    //销售汇总数据
    saleData(param) {
      let $totalparams = Object.assign({}, param);
      this.$axios
        .fetchPost(api.store.saleData, $totalparams)
        .then((data) => {
          if (data.code == 200) {
            let saledatabox = document.querySelectorAll(".sale-data-data div");
            for (let i = 0; i < saledatabox.length; i++) {
              saledatabox[0].innerHTML = data.data.allMoney;
              saledatabox[1].innerHTML = data.data.orderCount;
              saledatabox[2].innerHTML = data.data.refundMoney;
              saledatabox[3].innerHTML = data.data.refundCount;
              saledatabox[4].innerHTML = data.data.actualSum;
            }
          } else {
          }
        })
        .catch((err) => {
        });
    },
    //Top商品销售数据
    salesRanking(param) {
      let $goodsparams = Object.assign({}, param);
      this.$axios
        .fetchPost(api.store.salesRanking, $goodsparams)
        .then((data) => {
          if (data.code == 200) {
            this.tableData = data.data;
          }
        })
        .catch((err) => {
        });
    },
    sortNum(row, column, index) {
      return '<div>' + index + 1 + '</div>';
    },
    //支付方式汇总数据
    paymentSummary(param) {
      let $payparams = Object.assign({}, param);
      this.$axios
        .fetchPost(api.store.paymentSummary, $payparams)
        .then((data) => {
          if (data.code == 200) {
            this.paymentTotal = data.data
            this.rightTopPic.charsOption.series[0].data = [];
            let length = data.data.length;
            data.data.map((item) => {
              this.rightTopPic.charsOption.title.text = '';
              this.rightTopPic.charsOption.series[0].data.push({
                value: item.allMoney,
                name: item.payName,
              });
              this.rightTopPic.charsOption.legend.data.push(item.payName);
              this.rightTopPic.charsOption.legend.formatter = (name) => {//图例显示数据
                var total = 0;
                var tarValue;
                this.rightTopPic.charsOption.series[0].data.forEach(v => {
                  total += Number(v.value);
                  if (v.name == name) {
                    tarValue = v.value;
                  }
                })
                return `${name}  ${tarValue}元`;
              }
              if ((item.allMoney == null)) {
                item.allMoney = 0.00.toFixed(2)
                length = length - 1
              }
            });
            if (length == 0) {
              this.rightTopPic.charsOption.title.text = "暂无数据";
              this.rightTopPic.charsOption.title.top = 'center';
              this.rightTopPic.charsOption.title.left = 200;
            }
            this.$nextTick(() => {
              this.$refs.rightTopPic.drawpic();
            });
          }
        })
        .catch((err) => {
        });
    },
    //类比销售数据
    goodSellData(param) {
      let $sellparams = Object.assign({}, param);
      this.$axios
        .fetchPost(api.store.goodSellData, $sellparams)
        .then((data) => {
          if (data.code == 200) {
            if (data.data.length == 0) {
              // this.rightBottomRightPic.charsOption.title.text = "暂无数据";
              // this.rightBottomRightPic.charsOption.title.top = 'center'
              // this.rightBottomRightPic.charsOption.title.left = 'center'
              this.rightBottomRightPic.charsOption.legend.data = []
              this.rightBottomRightPic.charsOption.series[0].data = [{}]
            } else {
              this.tableSaleData = data.data
              this.rightBottomRightPic.charsOption.series[0].data = [];
              // this.rightBottomRightPic.charsOption.title.text = "大类销售金额";
              this.rightBottomRightPic.charsOption.title.top = 'top'
              var sum = 0;
              data.data.map((item) => {
                sum += Math.round(Number(item.goodsNum) * 100) / 100;
                if (this.activeTab == 'saleNumber') {//销量
                  // this.rightBottomRightPic.charsOption.title.text = `销售数量：${sum}`;
                  this.rightBottomRightPic.charsOption.series[0].data.push({
                    value: item.goodsNum,
                    name: item.goodsCategoryName,
                  });
                } else {//金额
                  sum += Math.round(Number(item.allSum) * 100) / 100;
                  // this.rightBottomRightPic.charsOption.title.text = `销售金额：￥${sum}`;
                  this.rightBottomRightPic.charsOption.series[0].data.push({
                    value: item.allSum,
                    name: item.goodsCategoryName,
                  });
                }
                this.rightBottomRightPic.charsOption.legend.data.push(item.goodsCategoryName)
                this.rightBottomRightPic.charsOption.legend.formatter = (name) => {//图例显示数据
                  var total = 0;
                  var tarValue;
                  this.rightBottomRightPic.charsOption.series[0].data.forEach(v => {
                    total += Number(v.value);
                    if (v.name == name) {
                      tarValue = v.value;
                    }
                  })
                  if (this.activeTab == 'saleNumber') {
                    return `${name}  ${tarValue}`;
                  } else {
                    return `${name}  ${tarValue}元`;
                  }
                }
              });
            }
            this.$nextTick(() => {
              this.$refs.rightBottomRightPic.drawpic();
            });
          }
        })
        .catch((err) => {
        });
    },
    //今日销售实时时段数据
    actualLineData() {
      this.$axios
        .fetchPost(api.store.actualLineData)
        .then((data) => {
          if (data.code == 200) {
            // let diedata = data.data;
            // this.leftTopPic.charsOption.series[0].data = diedata.allMoney;
            // this.leftTopPic.charsOption.series[1].data = diedata.orderCount;
            // this.leftTopPic.charsOption.xAxis.data = diedata.timeHour;
            // this.$nextTick(() => {
            //   this.$refs.leftTopPic.drawpic();
            // });
            this.saleHours.charsOption.xAxis.data = data.data.timeHour;
            this.saleHours.charsOption.series[0].data = data.data.allMoney;
            this.saleHours.charsOption.series[1].data = data.data.orderCount;
            this.$nextTick(() => {
              this.$refs.saleHours.drawpic();
            });
          }
        })
        .catch((err) => {
        });
    },
    lineSpeed() {
      this.timer = setInterval(() => {
        this.$axios.fetchPost(api.store.dynamicData).then((data) => {
          if (data.code == 200) {
            this.leftTopPic.charsOption.xAxis.data.push(data.data.timeHour);
            this.leftTopPic.charsOption.series[0].data.push(data.data.allMoney);
            this.leftTopPic.charsOption.series[1].data.push(
              data.data.orderCount
            );
            this.$nextTick(() => {
              this.$refs.leftTopPic.pushDataLeftTopPic(data);
            });
          }
        });
      }, 60000);
    },
    //查询
    searchSubmit() {
      let $payparams = Object.assign({}, this.params, this.$refs.storeTemplate.getSimpleParams());
      this.saleData($payparams)//销售汇总数据
      // this.paymentSummary($payparams); //支付方式汇总数据
      // this.goodSellData($payparams);//类比销售数据
      // this.salesRanking($payparams)//Top商品销售数据
      // this.businessAgent($payparams)
    },
    clearSearch() {
      // this.paymentSummary(this.params)
      // this.goodSellData(this.params)
      // this.salesRanking(this.params)
      this.saleData(this.param)
    },
    btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
  }
  ,
}
;
</script>
<style scoped>
.button-type {
  /*height: 30px;*/
  margin-left: -13px;
  /*padding-top:14px;*/
}

.home-total {
  background: #f2f2f2;
  padding: 1px 16px 10px 16px;
  box-sizing: border-box;
}

.home-total .container-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: -20px;
}

.home-total .container-left {
  width: 78%;
}

.home-total .container-right {
  width: 21.25%;
  margin-top: 14px;
}

.home-total .sale-data-list {
  display: flex;
  flex: 2;
  justify-content: space-between;
  align-items: center;
  margin: 14px 0;
}

.home-total .sale-data-list .sale-data-data {
  background: #fff;
  width: 19%;
  border-radius: 14px;
  padding: 15px;
  box-shadow: 5px 5px 5px #e1e1e1;
}

.home-total .sale-data-list .sale-data-data div {
  font-size: 28px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1280px) {
  .home-total .sale-data-list .sale-data-data .sale-data-title {
    font-size: 12px;
  }

  .home-total .container-right .mes-data .code .code-text p {
    font-size: 12px;
  }

  .home-total .container-right .mes-data #scrolldiv li {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .home-total .container-right .mes-data #scrolldiv1 li {
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .home-total .sale-data-list .sale-data-data {
    padding: 15px 5px;
  }
}

.home-total .charts-data {
  display: flex;
  justify-content: space-between;
  /*margin-bottom: 14px;*/
}

.charts-data .charts-data-list {
  width: 49.55%;
  height: 335px;
  background: #fff;
  border-radius: 8px;
  /*box-shadow: 5px 5px 5px #e5e5e5;*/
  border: 1px solid #e9e9e9;
}

.charts-data .charts-data-list > span {
  /*background: #F5F5F5;*/
  border-bottom: 2px solid #e9e9e9;
  display: block;
  padding: 13px 16px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: #333;
  font-weight: bold;
  font-size: 16px;
}

.charts-data .charts-data-list > div {
  background: #fff;
  padding: 12px;
}

.home-total .data-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.data-bottom .data-bottom-list {
  width: 49.55%;
  background: #fff;
  border-radius: 8px;
  /*box-shadow: 5px 5px 5px #e2e2e2;*/
  border: 1px solid #e9e9e9;
}

/*.data-bottom .data-bottom-list:nth-of-type(1) {*/
/*  width: 66%;*/
/*}*/

/*.data-bottom .data-bottom-list:nth-of-type(1) .list-template {*/
/*  width: 50%;*/
/*}*/

/*.data-bottom .data-bottom-list:nth-of-type(2) {*/
/*  width: 33%;*/
/*}*/

.data-bottom-list > span {
  border-bottom: 2px solid #e9e9e9;
  display: block;
  padding: 13px 16px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: #333;
  font-weight: bold;
  font-size: 16px;
}

.data-bottom-list > div {
  padding: 12px;
}

.data-bottom-list .table-header th,
.el-table__header {
  background: #fff;
  line-height: 15px;
  height: 15px;
}

.home-total .container-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 1rem;
}

.home-total .container-right .mes-data {
  width: 100%;
  /*box-shadow: 5px 5px 5px #e1e1e1;*/
  /*margin-bottom: 13px;*/
  height: 23.5%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
}

.home-total .container-right .mes-data1 {
  width: 100%;
  /*box-shadow: 5px 5px 5px #e1e1e1;*/
  /*margin-bottom: 13px;*/
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9e9e9;
}

.home-total .container-right .mes-data .code {
  background: #fff;
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.home-total .container-right .mes-data .code img {
  width: 120px;
  height: 120px;
  /*border: 1px solid #e0e0e0;*/
  display: block;
}

.home-total .container-right .mes-data .code p {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  color: #666;
  padding-top: 6px;
}

.home-total .container-right .mes-data > span {
  background: #fff;
  display: block;
  padding: 8px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: #333;
  font-weight: 600;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px solid #e9e9e9;
}

.home-total .container-right .mes-data1 > span {
  background: #fff;
  padding: 8px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: #333;
  font-weight: 600;
  width: 100%;
  display: block;
  font-size: 16px;
  border-bottom: 1px solid #e9e9e9;
}

.home-total .container-right .mes-data1 .block img {
  width: 100%;
  background: #303030;
}

.home-total .container-right .mes-data > span > i {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  cursor: pointer;
  color: #666;
}

.home-total .container-right .mes-data #scrolldiv {
  background: #fff;
  padding: 0 14px;
  height: 150px;
  overflow-y: auto;
  font-size: 14px;
}

.home-total .container-right .mes-data #scrolldiv #scroll1 {
  min-height: 116px;
}

.home-total .container-right .mes-data #scrolldiv #scroll2 {
  min-height: 116px;
}

.home-total .container-right .mes-data #scrolldiv1 #scroll11 {
  min-height: 116px;
}

.home-total .container-right .mes-data #scrolldiv1 #scroll21 {
  min-height: 110px;
}

.home-total .container-right .mes-data #scrolldiv li {
  list-style: none;
  background: #fff;
  line-height: 35px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-total .container-right .mes-data #scrolldiv1 {
  background: #fff;
  padding: 0 14px;
  height: 150px;
  overflow-y: auto;
  font-size: 14px;
}

.home-total .container-right .mes-data #scrolldiv1 li {
  list-style: none;
  background: #fff;
  line-height: 35px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.home-total .container-right .mes-data li[class~='oneColor']::before {
  content: attr(data-unit);
  display: inline-block;
  min-width: 20px;
  height: 20px;
  background: #ffeded;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-right: 4px;

  border-radius: 50%;
  color: #ff6763;
  border: 1px solid #ffe2e2;
}

.home-total .container-right .mes-data li[class~='twoColor']::before {
  content: attr(data-unit);
  display: inline-block;
  min-width: 20px;
  height: 20px;
  background: #fff7e8;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-right: 4px;

  border-radius: 50%;
  color: #f9a93a;
  border: 1px solid #fef1d9;
}

.home-total .container-right .mes-data li[class~='threeColor']::before {
  content: attr(data-unit);
  display: inline-block;
  min-width: 20px;
  height: 20px;
  background: #ecf5ff;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-right: 4px;

  border-radius: 50%;
  color: #65a9fc;
  border: 1px solid #deeeff;
}

.home-total .container-right .mes-data li[class~='fourColor']::before {
  content: attr(data-unit);
  display: inline-block;
  min-width: 20px;
  height: 20px;
  background: #eef9e8;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-right: 4px;

  border-radius: 50%;
  color: #66cc97;
  border: 1px solid #e0f4df;
}

.home-total .container-right .mes-data li[class~='fiveColor']::before {
  content: attr(data-unit);
  display: inline-block;
  min-width: 20px;
  height: 20px;
  background: #f7e8f9;
  font-size: 10px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  margin-right: 4px;

  border-radius: 50%;
  color: #b870ea;
  border: 1px solid #f5d7fd;
}

.home-total .container-right .mes-data #scrolldiv li > span {
  min-width: 20px;
  height: 20px;
  background: #458cff;
  display: inline-block;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  color: white;
  border-radius: 50%;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}

.home-total .container-right .mes-data #scrolldiv1 li > span {
  min-width: 20px;
  height: 20px;
  background: #458cff;
  display: inline-block;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  color: white;
  border-radius: 50%;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}

#imgbox {
  width: 500px;
  height: 500px;
  position: absolute;
  background: rgba(0, 0, 0, .3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  display: none;
}

#imgbox img {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
}

#imgbox .el-icon-circle-close {
  font-size: 30px;
  color: white;
  position: absolute;
  right: 0;
  padding-right: 8px;
  padding-top: 8px;
  cursor: pointer;
}

.home-total .right .el-carousel__button {
  width: 21px;
}

.data-bottom .list-template .el-table .cell {
  height: 34px;
  line-height: 34px;
}

.data-bottom >>> .el-table__body-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 267px;
}

.data-bottom-list .charts-box {
  width: 100%;
  height: 250px;
  padding: 2px;
  box-sizing: border-box;
}

.charts-data-list .charts-box {
  width: 100%;
  height: 250px;
  padding: 2px;
  box-sizing: border-box;
}

/*.charts-data-list .paymentData >>> .list-template .el-table .cell {*/
/*  line-height: 40px;*/
/*  height: auto;*/
/*}*/
.paymentData {
  width: 100%;
  display: flex;
}

.charts-data-list .charts-line {
  height: 250px;
  padding: 2px;
  box-sizing: border-box;
}

.data-bottom-list .paymentData >>> .list-template .el-table .cell {
  line-height: 40px;
  height: auto;
}

.data-bottom-list .charts-bottomLeft {
  height: 160px;
}

.charts-data-list .charts-bottomRight {
  height: 200px;
  /* width: calc(20vw - 53px); */
}


.centerBack3 {
  width: 100%;
  /*height: 240px;*/
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.echartsArea3 {
  width: 100%;
  /* min-height: 270px; */
}

.echartsArea3-empty {
  text-align: center;
  color: #ccc;
  padding-top: 80px;
}

.threeTable {
  height: 100%;
  width: 50%;
}

.threeTable >>> .el-table__body-wrapper {
  height: 130px;
  overflow-y: auto;
}

>>> .pagination-box {
  overflow: auto;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 140px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #fff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #fff;
}

.list-template {
  height: 100%;
}

.list-template >>> .el-table {
  height: 100%;
  overflow-y: auto;
}

.list-template >>> .el-table::before {
  height: 0;
}

div::-webkit-scrollbar {
  width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/homeTown.vue